exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-collapsible-element .collapsible-element-toggle{display:inline-flex;color:var(--fts-gray-5);font-size:.875rem;font-weight:300}.fts-collapsible-element .collapsible-element-toggle:hover{color:#2b9ec6;cursor:pointer}.fts-collapsible-element .collapsible-element-toggle.toggle-mb{margin-bottom:.75rem}", ""]);

// exports
